import BaseCrudService from "./baseCrud.service";

export default class ReceiverParcelamentService extends BaseCrudService {

    constructor() {
        super('ReceiverParcelament');
    }

    saveReceiverParcelament(saveReceiverParcelament) {
      this.postRequest('SaveReceiverParcelament', saveReceiverParcelament);
    }

    listAll() {
      return this.getRequest('GetReceiverParcelaments');
    }

    listReceiverParcelaments() {
      return this.getRequest('ListReceiverParcelaments');
    }

    save(receiverParcelament) {
      return this.putRequest('Save', receiverParcelament);
    }
}